export default __webpack_public_path__ + "static/kolio-zdravkov-7817ec1a8843a983a8427e3265eecdb5.jpg";